export * from './view-item.component';
export * from './view-item.module';
